/* Original BlackPatel interface enhancement. Commerce uses native Dawn and Shopify. */
document.addEventListener('change', (event) => {
  if (!event.target.matches('.bp-unit-switch input')) return;
  const guide = event.target.closest('.bp-size-guide');
  const inches = event.target.value === 'in';
  guide.querySelectorAll('[data-cm]').forEach(cell => {
    cell.textContent = inches
      ? cell.dataset.cm.split('–').map(value => (Number(value) / 2.54).toFixed(1)).join('–')
      : cell.dataset.cm;
  });
  guide.querySelector('.bp-size-note').textContent = inches
    ? 'Measurements are in inches, rounded to one decimal. If you are between sizes, choose the larger size. Fit varies by design.'
    : 'Measurements are in centimetres. If you are between sizes, choose the larger size. Fit varies by design.';
});

// Accessible sizing dialog: native modal focus containment and Escape dismissal.
document.addEventListener('click', event => {
  const opener = event.target.closest('[data-bp-size-open]');
  if (opener) { const dialog = document.getElementById(opener.dataset.bpSizeOpen); if (dialog) { dialog.showModal(); dialog._opener = opener; } }
  const closer = event.target.closest('[data-bp-size-close]');
  if (closer) closer.closest('dialog').close();
  if (event.target.matches('dialog.bp-size-dialog')) { const box = event.target.getBoundingClientRect(); if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) event.target.close(); }
});
